<!-- Rendered inside the lot-details vb-dialog, which owns the title + close. -->
<div class="parent-container">
    <div *ngIf="lotItemUserNotes.length > 0">
        <table class="notes-table">
            <thead>
                <tr>
                    <th class="first-column">Date/Time</th>
                    <th class="second-column">Notes</th>
                </tr>
            </thead>
            <tbody class="table-body">
                <tr *ngFor="let note of lotItemUserNotes; let i = index">
                    <td class="first-column">
                        <div>{{ note.createdOn | vbDate }}</div>
                        <div class="note-time">{{ note.createdOn | vbTime }}</div>
                    </td>
                    <td
                        class="second-column"
                        [innerHTML]="sanitizeHtml(note.note ?? '')"></td>
                    <td class="actions menu-icon-wrapper mt-1">
                        <img
                            src="../../../../../../../assets/img/icon/icon_ellipses.svg"
                            class="menu-icon"
                            alt="More"
                            (click)="toggleNotesActionDropdown(i, $event)"
                            tabindex="0"
                            (keyup.enter)="toggleNotesActionDropdown(i, $event)"
                            data-bs-toggle="tooltip"
                            title="More" />
                        <div
                            *ngIf="activeMenuIndex === i"
                            class="dropdown-menu"
                            (click)="onDropdownClick($event)"
                            (keyup.enter)="onDropdownClick($event)"
                            tabindex="0">
                            <div
                                tabindex="0"
                                (click)="deleteNote(note.id ?? '')"
                                (keyup.enter)="deleteNote(note.id ?? '')"
                                class="d-flex align-items-center clickable-text notes-menu">
                                <img
                                    src="../../../../../../assets/img/icon/icon_delete.svg"
                                    alt="delete icon" />
                                <p class="mt-3">Delete Note</p>
                            </div>
                            <div
                                tabindex="0"
                                (click)="applyEditMode(note)"
                                (keyup.enter)="applyEditMode(note)"
                                class="d-flex align-items-center clickable-text notes-menu">
                                <img
                                    src="../../../../../../assets/img/icon/icon_edit.svg"
                                    alt="edit icon" />
                                <p class="mt-3">Edit Note</p>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="vb-add-note" *ngIf="!showNotesEditor">
        <ng-template #addNoteIcon>
            <vb-icon name="plus" [size]="16" />
        </ng-template>
        <vb-button
            variant="secondary"
            size="sm"
            [iconLeft]="addNoteIcon"
            (clicked)="showEditor()">
            Add Note
        </vb-button>
    </div>
    <div *ngIf="showNotesEditor" class="mt-3">
        <p class="bold">{{ noteEditorLabel }}</p>
        <!-- Plain-text notes: the browser maxlength caps input at exactly the
             stored/sent length — no HTML markup to blow past the limit. -->
        <textarea
            class="vb-note-input"
            rows="6"
            [formControl]="noteFormControl"
            [attr.maxlength]="maxNoteLength"
            [placeholder]="'LotDetails.placeHolderEnterNote' | translate"></textarea>
        <div
            class="vb-note-charcount"
            [class.vb-note-charcount--max]="noteCharCount >= maxNoteLength">
            {{ noteCharCount }} / {{ maxNoteLength }}
        </div>
        <div class="button-container mt-4">
            <vb-button variant="ghost" (clicked)="showEditor()">
                Cancel
            </vb-button>
            <vb-button
                variant="primary"
                (clicked)="isEditMode ? editNote() : saveNote()">
                Save Note
            </vb-button>
        </div>
    </div>
</div>
